import React from 'react';
import ImageLazy from '../common/ImageLazy';
import PlayButton from '../PlayButton/PlayButton';


const SceneImage = ({ data, maxWidth, imagesRatio, position, onClick }) => {
  let divStyle = { position: "relative", width: "100%" };
  let imgStyle = { width: "100%", maxWidth: `${maxWidth}px` };
  let imgSrc;
  let image_id = data.clip_id || data.banner_id;
  if (data.imageSrc) imgSrc = data.imageSrc;
  else {
    imgSrc = `https://transform.gammacdn.com/movies${data.thumbnail}`;
  }

  return (
    <div style={divStyle} key={image_id} onClick={onClick}>
        <ImageLazy maxWidth={maxWidth} src={imgSrc} ratio={data.ratio||imagesRatio} style={imgStyle} data-id={image_id} alt={data.title||''}/>
        {data.clip_id &&<PlayButton/>}
    </div>
  );
};

export default SceneImage;
